import React, { useEffect, useRef, useState } from 'react'
import { Box, Container, Grid } from '@material-ui/core'
import {
  AnimatedText,
  FAQAccordion,
  LinkWithIcon,
  SideMenu,
  XRayText,
} from '../../components'
import { useStyles } from './faqs.style'
import { useOnScreen } from '../../utils/dom'
import { contentfulArrayToObject } from '../../utils/cms'

const FAQPage = ({ data = {} }) => {
  const featureEntries = contentfulArrayToObject(data.feature || [])

  const [
    { sectionHeadings: faqsSectionHeading },
    { sectionHeadings: goToContactPageHeading },
  ] = featureEntries.ContentfulSectionHeading || {}
  const miniSlash = featureEntries.ContentfulImageAnimation?.image?.file.url
  const { faqs: faqItems } = featureEntries.ContentfulPageFaqs || {}
  const { link: contactUsLink, text: contactUsLinkText } =
    featureEntries.ContentfulButton || {}

  const [activeSideMenuIndex, setActiveSideMenuIndex] = useState(0)
  const slashRef = useRef(null)
  const styles = useStyles()

  const referencesForFAQsSection = {}
  faqItems.forEach((faqItem, index) => {
    referencesForFAQsSection[`faq-heading-${index}`] = useRef(null)
  })

  const faqOnScreen = {}
  Object.entries(referencesForFAQsSection).forEach((faqSection, index) => {
    faqOnScreen[`onscreen-${index}`] = useOnScreen(faqSection[1])
  })

  useEffect(() => {
    const visibleFaqBlock = Object.entries(faqOnScreen).filter(
      (faqBlock) => faqBlock[1] === true,
    )
    if (visibleFaqBlock.length > 0) {
      const [visibleFaqBlockName] = visibleFaqBlock[0]
      const visibleFaqBlockIndex = visibleFaqBlockName.split('-')[1]

      setActiveSideMenuIndex(Number(visibleFaqBlockIndex))
    }
  }, [faqOnScreen])

  return (
    <main>
      {/* First Heading with Blue Background */}
      <Box className={styles.bannerContainer}>
        <Container maxWidth="lg">
          <Box className={styles.bannerText}>
            {faqsSectionHeading && (
              <AnimatedText
                animationType="wavy"
                variant="h2"
                content={faqsSectionHeading}
              />
            )}
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg">
        <Grid container className={styles.mainFaqContainer}>
          <Box className={styles.fullWidthSpacer} />
          <Grid item lg={4} md={4} xs={12} className={styles.faqSidebar}>
            {/* Side menu */}
            <SideMenu
              headingPrefix={'faqs'}
              miniSlashPath={miniSlash}
              sideMenuItem={faqItems}
              slashRef={slashRef}
              activeSideMenuIndex={activeSideMenuIndex}
            />
          </Grid>

          {/* FAQ sections with accordions */}
          <Grid item lg={8} md={8} xs={12}>
            {faqItems.map((faqItem, faqItemIndex) => {
              return (
                <div
                  ref={referencesForFAQsSection[`faq-heading-${faqItemIndex}`]}
                  key={`faqHeadingKey-${faqItemIndex}`}
                  className={styles.faqContainer}
                >
                  <Box
                    className={styles.fullWidthSpacer}
                    id={`faqs-heading-${faqItemIndex}`}
                  />
                  <XRayText
                    variant="h3"
                    wrapperClass={styles.primaryHeading}
                    content={faqItem.faqHeading}
                  />
                  <FAQAccordion faqs={faqItem.faQs} />
                </div>
              )
            })}
          </Grid>
          <Grid item className={styles.goToContactHeadingSection}>
            {goToContactPageHeading && (
              <XRayText
                variant="h3"
                wrapperClass={styles.goToContactHeading}
                content={goToContactPageHeading}
              />
            )}

            <Box className={styles.contactLinkSection}>
              <LinkWithIcon text={contactUsLinkText} to={contactUsLink} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </main>
  )
}

export default FAQPage
